<script lang="ts" setup>
import { ToastViewport } from 'reka-ui';
import Toast from './Toast.vue';
import { useToastStore } from './useToast';

const toastStore = useToastStore();
</script>

<template>
  <ToastViewport
    class="fixed top-0 z-toast flex max-h-screen w-full flex-col-reverse items-end gap-4x p-4x"
  />

  <Toast
    v-for="toast in toastStore.toasts"
    :key="toast.openedAt"
    v-model:open="toast.isOpen"
    :type="toast.type"
    :action-icon="toast.options?.actionIcon"
    :action-text="toast.options?.actionText"
    @update:open="toastStore.remove(toast)"
    @action-click="toast.options?.actionCallback"
  >
    {{ toast.text }}
  </Toast>
</template>
